export default "__VITE_ASSET__1409c4e2__"